import type { ComponentProps } from 'react';
import { cn } from '@/utils/cn';

/**
 * Text input. `aria-invalid` drives the error styling so the visual state and the state announced to a
 * screen reader can never disagree.
 */
export function Input({ className, ...props }: ComponentProps<'input'>): React.JSX.Element {
  return (
    <input
      className={cn(
        'h-10 w-full rounded-md border border-line-strong bg-surface px-3 text-sm',
        'disabled:cursor-not-allowed disabled:bg-surface-muted',
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}
